// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Context = require("../../../../provider/Context.bs.js");
var Atom_Box = require("../../../atom/Atom_Box.bs.js");
var Atom_Cta = require("../../../atom/Atom_Cta.bs.js");
var Atom_Row = require("../../../atom/Atom_Row.bs.js");
var Atom_Logo = require("../../../atom/Atom_Logo.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Atom_Column = require("../../../atom/Atom_Column.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../../../../type/Type_Common.bs.js");
var Atom_Divider = require("../../../atom/Atom_Divider.bs.js");
var Particle_Screen_Ds = require("../../../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../../../particle/Particle_Spacer_Ds.bs.js");
var Organism_Header_Css = require("../Organism_Header_Css.bs.js");
var Organism_SettingsMenu = require("../Organism_SettingsMenu.bs.js");
var Particle_Background_Ds = require("../../../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../../../particle/Particle_Screen_Constants.bs.js");

function Organism_MenuNavigation(Props) {
  var menuNavigation = Props.menuNavigation;
  var state = Props.state;
  var category = Props.category;
  var ffUserPanel = Context.Config.getFeatureFlippingStatus(/* UserPanel */7);
  var categories = menuNavigation.categories;
  var match = Context.I18n.getState(undefined);
  var match$1 = match.labels.accessibility;
  var newWindowLabel = match$1.newWindow;
  var activeLink = category !== undefined ? Belt_Array.getBy(categories, (function (category$1) {
            return category === category$1.code;
          })) : undefined;
  if (state) {
    return null;
  } else {
    return React.createElement(Atom_Row.make, {
                background: Particle_Background_Ds.dropdownMenu,
                blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S")),
                children: null,
                rules: Organism_Header_Css.MenuNavigation.rules,
                wrap: /* OnOneLine */1
              }, React.createElement(Atom_Column.make, {
                    blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeLeft("S")), undefined, undefined, Particle_Spacer_Ds.makeNone(undefined)),
                    children: React.createElement(Atom_Logo.make, {
                          logo: {
                            NAME: "ArteVerticalLogo",
                            VAL: "MenuNavigation"
                          }
                        }),
                    justifyContent: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center")
                  }), React.createElement(Atom_Box.make, {
                    children: null,
                    direction: Particle_Screen_Ds.make(undefined, undefined, "row", undefined, undefined, "column"),
                    spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("S")),
                    width: Particle_Screen_Constants.oneHundredPctWidth
                  }, React.createElement(Atom_Column.make, {
                        children: Belt_Array.map(menuNavigation.mobileLinks, (function (param) {
                                return React.createElement(Atom_Cta.Link.make, {
                                            href: param.href,
                                            label: param.label,
                                            style: {
                                              TAG: /* Header */10,
                                              _0: {
                                                TAG: /* MenuNavigation */8,
                                                _0: /* Inactive */1
                                              }
                                            },
                                            key: param.id
                                          });
                              })),
                        display: Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "inlineFlex")
                      }), React.createElement(Atom_Divider.make, {
                        style: Atom_Divider.menuNavigation,
                        display: Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "inlineFlex")
                      }), React.createElement(Atom_Column.make, {
                        blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeRight("M")),
                        children: Belt_Array.map(categories, (function (param) {
                                var href = param.href;
                                var buttonStyle = activeLink !== undefined && activeLink.code === param.code ? ({
                                      TAG: /* Header */10,
                                      _0: {
                                        TAG: /* MenuNavigation */8,
                                        _0: /* Active */0
                                      }
                                    }) : ({
                                      TAG: /* Header */10,
                                      _0: {
                                        TAG: /* MenuNavigation */8,
                                        _0: /* Inactive */1
                                      }
                                    });
                                return React.createElement(Atom_Cta.Link.make, {
                                            href: href,
                                            label: param.label,
                                            style: buttonStyle,
                                            key: href
                                          });
                              }))
                      }), React.createElement(Atom_Divider.make, {
                        style: Atom_Divider.menuNavigation,
                        display: Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "inlineFlex")
                      }), React.createElement(Atom_Column.make, {
                        children: null
                      }, Belt_Array.map(menuNavigation.otherLinks, (function (param) {
                              var href = param.href;
                              var label = param.label;
                              var match = Type_Common.linkKindFromJs(param.kind);
                              if (match === "external_") {
                                return React.createElement(Atom_Cta.Link.make, {
                                            href: href,
                                            label: label,
                                            screenReadersLabel: "(" + newWindowLabel + ")",
                                            style: {
                                              TAG: /* Header */10,
                                              _0: {
                                                TAG: /* MenuNavigation */8,
                                                _0: /* External */2
                                              }
                                            },
                                            target: "Blank",
                                            key: href
                                          });
                              }
                              return React.createElement(Atom_Cta.Link.make, {
                                          href: href,
                                          label: label,
                                          style: {
                                            TAG: /* Header */10,
                                            _0: {
                                              TAG: /* MenuNavigation */8,
                                              _0: /* Inactive */1
                                            }
                                          },
                                          key: href
                                        });
                            })), ffUserPanel ? React.createElement(Organism_SettingsMenu.Link.make, {}) : null)));
  }
}

var make = Organism_MenuNavigation;

exports.make = make;
/* react Not a pure module */
